import { Loader } from 'rsuite';

import ProviderIcon from './ProviderIcon';
import './ProviderBadge.css';

// Colors live in ProviderBadge.css (not inline) so the dark theme can restyle the badge.
export default function ProviderBadge({ provider, isLoading }) {
  if (isLoading) {
    return (
      <span className="ppc-provider-badge">
        <Loader size="xs" />
        <span>Loading provider…</span>
      </span>
    );
  }

  const name = provider?.displayName || provider?.name || null;

  if (!name) {
    return (
      <span className="ppc-provider-badge ppc-provider-badge--missing" title="No hours provider configured">
        <i className="bi bi-exclamation-triangle-fill" aria-hidden="true" />
        <span>No provider configured</span>
      </span>
    );
  }

  return (
    <span className="ppc-provider-badge" title={`Data from: ${name}`}>
      <ProviderIcon icon={provider?.icon} size={14} />
      <span>
        Data from: <span className="ppc-provider-badge__name">{name}</span>
      </span>
    </span>
  );
}
